module.exports = {
      id: "icon-Settings-usage",
      viewBox: "0 0 512 512",
      url: "/img/" + "063d56c0a9dcab4c3026b31719d540d0.svg#icon-Settings",
      toString: function () {
        return this.url;
      }
    }